import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicVerifAnnonces = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
    const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
    if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
    { label: 'Questions de sécurité', link: '/topics/securite/question-securite'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous ne devriez pas avoir à vous inquiéter du fait qu'une annonce est fausse ou qu'une compétition ne se trouve pas à l'endroit indiqué. 
              C'est pourquoi nous avons mis en place une nouvelle procédure permettant aux organisateurs de démontrer que leur compétition est réelle.
            </p>
            <p className="help-text">Toutes nos annonces répondent aux critères de vérification décrites dans cet article.</p>
            <p className="help-text">
              Notre processus de vérification permet de confirmer uniquement que la compétition est réelle et que son emplacement est exact. 
              Nous ne vérifions pas la description de l'annonce par l'organisateur ni les autres informations fournies sur son event.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Nous employons différentes méthodes pour mener à bien cette procédure. Avant de publier une nouvelle annonce, les organisateurs collaborent 
                avec nos équipes afin de définir les options les mieux adaptées à la compétition qu’ils souhaitent organiser. Ils bénéficient d’un accompagnement pas 
                à pas, assurant ainsi l’exactitude et la fiabilité des informations.
              </p>
              <p className="help-text"><strong>Méthodes de vérification :</strong></p>
              <ul>
                <li className="help-text pl-8 mb-16">
                  <strong>Description :</strong> nous invitons les organisateurs à fournir une description détaillée du déroulement de la compétition, 
                  en précisant clairement les standards attendus.
                </li>
                <li className="help-text pl-8 mb-16">
                  <strong>Documents :</strong> pour toute compétition avec des inscriptions payantes, nous collaborons avec Stripe afin de garantir 
                  la sécurité de vos paiements. Les organisateurs doivent fournir des documents justificatifs pour valider leur identité.
                </li>
                <li className="help-text pl-8 mb-16">
                  <strong>Données :</strong> nous effectuons des contrôles réguliers des données affichées sur notre plateforme afin de détecter et de corriger toute incohérence.
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Les athlètes doivent pouvoir réserver en sachant que la compétition qu'ils ont choisi est réelle 
                C'est pourquoi nous avons mis en place une procédure visant à vérifier les annonces publiées par les athlète sur Wodzone.
              </p>
              <p className="help-text">
                Malgré toutes nos précautions, aucune procédure de vérification n'est infaillible, nous ne pouvons donc pas garantir l'emplacement d'une 
                compétition. Notre procédure de vérification comprend certaines limites, notamment sur les points suivants :
              </p>
              <ul>
                <li className="help-text pl-8 mb-16">
                  De potentielles activités frauduleuses peuvent contourner nos contrôles de sécurité.
                </li>
                <li className="help-text pl-8 mb-16">
                  La vérification ne tient pas compte des problèmes de sécurité ou de qualité de l'annonce.
                </li>
                <li className="help-text pl-8 mb-16">
                  Seules les informations que nous demandons à l'organisateur de compléter dans le cadre de la vérification de l'annonce sont vérifiées. 
                  Tout autre renseignement publié par l'organisateur sur son annonce ne sera pas vérifié, comme les détails WODs, les standards demandés etc.
                </li>
                <li className="help-text pl-8 mb-16">
                  Nous ne contrôlons pas la précision de l'annonce, même si elle a été vérifiée.
                </li>
              </ul>
              <p className="help-text">
                Si vous avez encore besoin d'aide au sujet de votre hôte ou du logement, cliquez sur 
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>Nous contacter.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicVerifAnnonces